import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useSelector } from "react-redux";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { useAppDispatch } from "../Core/store.hooks";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import Info from "./Info";
import InfoCategory from "./InfoCategory";
import InfoLibrary from "./infoLibrary";


type handler = () => void;
interface infoProps {
  visible: boolean;
  toggleVisible: handler;
  id: string;
}

const Information = (props: infoProps) => {
  const [title, updateTitle] = useState("Help");

  useEffect(() => {
      if (props.id != null) {
          for (var i = 0; i < InfoLibrary.length; i++) {
              if (props.id == InfoLibrary[i].id) {
                  updateTitle(InfoLibrary[i].title);
              }
          }
      }
  }, [props.id]);

    const renderContent = () => {
        if (title== "Help") {
            return (<Info category={title} toggleVisible={props.toggleVisible } />);
        }
        else {
            return <InfoCategory category={title} />;
        }
    }
  const renderDialog = () => {
    if (props.visible) {
      return (
        <Dialog title={title} onClose={props.toggleVisible} width={1000}>
              <div style={{ backgroundColor: "#fff", padding: "20px" }}>
                  {renderContent()}
                </div>
          <DialogActionsBar>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={props.toggleVisible}
            >
              Close
            </button>
          </DialogActionsBar>
        </Dialog>
      );
    }
    return null;
  };
  return renderDialog();
};

export default Information;
